webpackJsonp([272258082923381],{

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Card = function Card(_ref) {
	    var fullname = _ref.fullname,
	        username = _ref.username;
	    return _react2.default.createElement(
	        "a",
	        { href: "https://github.com/" + username, className: "profile" },
	        _react2.default.createElement("img", { src: "https://avatars1.githubusercontent.com/" + username + "?size=200" }),
	        _react2.default.createElement(
	            "p",
	            null,
	            fullname
	        )
	    );
	};
	
	exports.default = Card;
	module.exports = exports["default"];

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.profileQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(16);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _userCard = __webpack_require__(196);
	
	var _userCard2 = _interopRequireDefault(_userCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Submission = function Submission(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    { className: 'card-container' },
	    data.allMarkdownRemark.edges.map(function (profile) {
	      return _react2.default.createElement(_userCard2.default, { username: profile.node.frontmatter.username,
	        fullname: profile.node.frontmatter.fullname });
	    })
	  );
	};
	
	exports.default = Submission;
	var profileQuery = exports.profileQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-submissions-js-7792c7208b40885dbb98.js